<template>
  <div class="not-found">
    <div class="img">
      <img :src="imgData.null" alt />
      <div>404页面</div>
    </div>
    <van-button  type="info" size="large" to="/home">回到首页</van-button>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "vant";
Vue.use(Button);
export default {
  name: "Unfound",
  components: {},
  data() {
    return {
        imgData: {
            null: '/img/null.svg'
        },
    };
  }
};
</script>

<style lang="scss" scoped>
.not-found {
  padding: 0.15rem;
  .img {
    background-color: #fff;
    text-align: center;
    color: #999;
    font-size: 0.3rem;
    line-height: .5rem;
    padding: .15rem;
    margin-bottom: .1rem;

    @include border-radius(.1rem);
  }

  .van-button--info{
      background-color: #378EDE;
      @include border-radius(.1rem);
  }
}
</style>
